module.exports = __webpack_public_path__ + "static/media/contact.e597e29c.svg";